export default __webpack_public_path__ + "static/media/jgi_logo.96457097.jpg";